import React, { useState } from 'react';
import { Button, FormControl, InputLabel, Input, FormGroup, Checkbox, FormControlLabel } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getAddModalStyles } from '../../SiteManagement/styles'; //TODO EXPORT THESE HIGHER!
import { SSOProviderDTO, Environments } from '@beable/roster-backend-client-v1';
import { SUBPAGES } from "../constants";
import EnvironmentSelector from '../../Common/Selectors/EnvironmentSelector';
import { InputLengthHelperText } from "../../Common/FormModal";

interface ProviderFormProps {
    onSubmit: (providerDto: SSOProviderDTO, allEnvs: boolean) => void;
    handleClose: any;
    selectedItem?: SSOProviderDTO;
}

export default function ProviderForm(props: ProviderFormProps) {
    const theme = useTheme();
    const styles = getAddModalStyles(theme);

    const [allEnvs, setEnableForAllEnvs] = useState(false);
    const [ssoProvider, setSSOProvider] = useState<SSOProviderDTO>(props.selectedItem ?? SUBPAGES.providers.defaultState);

    const hasBlankFields = () => {
        return !ssoProvider.name.length || !ssoProvider.environment;
    }

    const providerDataChangeHandler = (e: any) => {
        const { target: { name, value } } = e;
        setSSOProvider((ssoProvider: SSOProviderDTO) => { return { ...ssoProvider, [name]: value } });
    }

    const handleSetAllEnvs = (e: any) => setEnableForAllEnvs(e.target.checked);

    const resetState = () => {
        setEnableForAllEnvs(false);
        setSSOProvider(SUBPAGES.providers.defaultState);
    }

    const submitForm = async () => {
        if (allEnvs) ssoProvider.environment = Environments.qa;
        props.onSubmit(ssoProvider, allEnvs);
    };

    return <>
        <FormGroup>
            <FormControl variant="standard" margin="dense">
                <InputLabel htmlFor="name">Name*</InputLabel>
                <Input onChange={providerDataChangeHandler} value={ssoProvider.name} name="name" id="name" aria-describedby="provider name" />
                <InputLengthHelperText str={ssoProvider.name} />
            </FormControl>
            <FormControl
                variant="standard"
                margin="dense"
                sx={allEnvs ? styles.dnone : styles.dflex}>
                <EnvironmentSelector 
                    env={ssoProvider.environment}
                    onChange={providerDataChangeHandler}
                    labelText={"Environment*"}
                />
            </FormControl>
            {!props.selectedItem && (
            <FormControlLabel
                control={
                    <Checkbox name='allEnvs' sx={styles.cbs} checked={allEnvs} onChange={handleSetAllEnvs} />
                }
                label="Add for all environments"
            />
            )}
            <FormControl variant="standard" margin="dense">
                <InputLabel htmlFor="customerIdentifier">Customer Identifier</InputLabel>
                <Input onChange={providerDataChangeHandler} value={ssoProvider.customerIdentifier} name="customerIdentifier" id="customerIdentifier" aria-describedby="provider customerIdentifier" />
                <InputLengthHelperText str={ssoProvider.customerIdentifier} />
            </FormControl>
            <FormControl variant="standard" margin="dense">
                <InputLabel htmlFor="userIdentifier">User Identifier</InputLabel>
                <Input onChange={providerDataChangeHandler} value={ssoProvider.userIdentifier}
                    name="userIdentifier" id="userIdentifier" aria-describedby="provider userIdentifier" />
                <InputLengthHelperText str={ssoProvider.userIdentifier} />
            </FormControl>
            <FormControl variant="standard" margin="dense">
                <InputLabel htmlFor="userIdentifierAccessor">User Identifier Accessor</InputLabel>
                <Input onChange={providerDataChangeHandler} value={ssoProvider.userIdentifierAccessor}
                    name="userIdentifierAccessor" id="userIdentifierAccessor" aria-describedby="provider userIdentifierAccessor" />
                <InputLengthHelperText str={ssoProvider.userIdentifierAccessor} />
            </FormControl>
            <FormControl variant="standard" margin="dense">
                <InputLabel htmlFor="redirectUrl">Redirect URL</InputLabel>
                <Input onChange={providerDataChangeHandler} value={ssoProvider.redirectUrl} name="redirectUrl"
                    id="redirectUrl" aria-describedby="provider redirect url" />
                <InputLengthHelperText str={ssoProvider.redirectUrl} />
            </FormControl>
        </FormGroup>
        {/* BUTTONS */}
        <FormGroup sx={[styles.mt2, styles.dfr]}>
            <Button variant="contained" color="primary" disabled={hasBlankFields()}
                onClick={submitForm}>{ (props.selectedItem ? 'Edit' : 'Add provider') }</Button>
            <Button
                variant="contained"
                onClick={() => {
                    resetState();
                    props.handleClose();
                }}
                sx={styles.ml2}>Close</Button>
        </FormGroup>
    </>;
}